import { render } from "./ComponentsParts.vue?vue&type=template&id=6c4f6bb8&scoped=true"
import script from "./ComponentsParts.vue?vue&type=script&lang=js"
export * from "./ComponentsParts.vue?vue&type=script&lang=js"

import "./ComponentsParts.vue?vue&type=style&index=0&id=6c4f6bb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4f6bb8"]])

export default __exports__